import { MfaPage } from '@mfa/commun-react';
import React, { Component } from 'react';
import { Article } from './Article'
import { Presentation } from './Presentation';
import './Page.js.css';

export class Page extends Component {
    render() {
        if (window.location.pathname.includes('Presentation')) {
            return (
                <div className='presentation'>
                    <MfaPage
                        titre='Présentation des sanctions pénales'
                        adresseRoutes="api/PSP/ObtenirRoutes"
                        proprietesRoutes={{}}
                        dictionnaireRoutes={{
                            Presentation: Presentation,
                            Article: Article,
                        }}
                        fermetureSessionInfo={{}}
                    >
                    </MfaPage>
                </div>
            );
        }
        if (window.location.pathname.includes('Article')) {
            return (
                <div className='article'>
                    <MfaPage
                        titre='Article de loi ou règlement'
                        adresseRoutes="api/PSP/ObtenirRoutes"
                        proprietesRoutes={{}}
                        dictionnaireRoutes={{
                            Presentation: Presentation,
                            Article: Article,
                        }}
                        fermetureSessionInfo={{}}
                    >
                    </MfaPage>
                </div>
            );
        }
    }
}
